export const NavigationContainer = `fixed top-0 bg-black h-20 flex justify-center items-center py-4 w-full z-30`
export const SectionsWrapper = 'xl:container px-10 w-full flex justify-between items-center'
export const LogoSection = `w-1/3`
export const ButtonSection = `w-1/3 flex justify-center`
export const LinkSection = `flex flex-row w-1/3 justify-end inline-flex items-center`
export const LogoutButton = 'block w-full text-left px-4 py-3 text-sm'
